import React from 'react';
import { cn } from '@/lib/utils';

export const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className, 
  disabled,
  type = 'button',
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-cyan)]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--background)] disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98] tracking-tight';
  
  const variants = {
    primary: 'bg-[var(--text-primary)] text-[var(--background)] hover:opacity-90 shadow-sm',
    secondary: 'bg-[var(--surface-hover)] text-[var(--text-primary)] border border-[var(--border)] hover:bg-[var(--border)]',
    accent: 'bg-[var(--brand-cyan-muted)] text-[var(--brand-cyan)] border border-[var(--brand-cyan)]/30 hover:bg-[var(--brand-cyan-strong)] hover:border-[var(--brand-cyan)]/50',
    success: 'bg-[var(--status-success)] text-white hover:opacity-90 shadow-sm',
    danger: 'bg-[var(--status-danger)] text-white hover:opacity-90 shadow-sm',
    ghost: 'bg-transparent text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--surface-hover)]',
    outline: 'bg-transparent border border-[var(--border)] text-[var(--text-primary)] hover:bg-[var(--surface-hover)] hover:border-[var(--border-strong)]'
  };
  
  const sizes = {
    sm: 'px-3 py-1.5 text-xs gap-1.5',
    md: 'px-4 py-2 text-sm gap-2',
    lg: 'px-5 py-2.5 text-sm gap-2'
  };
  
  return (
    <button
      type={type}
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
